export default String.raw`
.blog-container {
    $cgap: 24px;
    width: 685px + $cgap;

    &__title {
        h1{
            @include h2-headline;
        }
       
        margin-bottom: 30px;
    }

    &__list {
        $columns-width: calc((100% - $cgap) / 2);
        grid-template-columns: repeat(2, $columns-width);
    }
}
`